import React from 'react'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import './Banner.scss'

const Banner = () => {
  // Cấu hình slider
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    cssEase: 'ease-in-out'
  }

  const banners = [
    '/banner1.jpg',
    '/banner2.jpg',
    '/banner3.jpg'
  ]

  return (
    <div className='banner-pages'>
      <Slider {...settings}>
        {banners.map((image, index) => (
          <div className='item-banner' key={`banner-${index}`}>
            <Link to='#'>
              <div className='banner-img'>
                <img src={image} alt={`Slide ${index + 1}`} loading='lazy' />
              </div>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  )
}

export default Banner
